import Uploader from "vux-uploader-component";

const errorColor    = '#f44336';
const borderColor   = '#424242';
const titleColor    = '#000000';
const infoColor     = '#b2b2b2';

export default {
    components: {
        Uploader
    },
    props: {
        title: {
            type : String,
            default: 'Photo-Uploader'
        },
        limit : {
            type    : Number,
            default : 5
        },
        required : {
            type    : Boolean,
            default : false
        },
        minLength : {
            type    : Number,
            default : 0
        }
    },
    data() {
        return {
            fileList        : [],
            autoUpload      : false,
            // borderStyle     : this.setStyleColors()
            borderStyle     : 'border: 1px dashed #424242;',
            titleClass      : 'vux-uploader_title',
            infoClass       : 'vux-uploader_info',
            hasErrors       : false
        };
    },
    computed : {
        // borderStyle : {
        //     get: function () {
        //         return 'border: 1px dashed ' + borderColor + ';';
        //     },
        //     // setter
        //     set: function (value) {
        //         console.info('errrrrrorrrr', value);
        //         return value;
        //     }
        // },
    },
    methods :  {
        setStyleColors(error) {
            // console.warn('errorColor', errorColor);
            var title = document.getElementsByClassName(this.titleClass)[0];
            var info  = document.getElementsByClassName(this.infoClass)[0];
            if (error) {
                title.style.color = errorColor;
                info.style.color = errorColor;
                this.borderStyle = 'border: 1px dashed ' + errorColor + ';';
            } else {
                info.style.color = infoColor;
                title.style.color = titleColor;
                this.borderStyle = 'border: 1px dashed ' + borderColor + ';';
            }
        },
        onChange(item, list) {
            console.info('event: onChange', item, list);
            if(list.length > this.limit) {
                alert(error);
            }
        },
        onCancel() {
            console.info('event: onCancel');
        },
        onSuccess(result, item) {
            console.info('event: onSuccess');
        },
        onError(error) {
            console.info('event: onError', error);
        },
        onDelete(cb) {
            // setTimeout(() => {
                console.log('on-delete: ', JSON.parse(JSON.stringify(this.fileList)))
                cb && cb()
            // }, 3000);
        },
        submit() {
            const formData = new FormData();
            formData.append("file", fileList[0].blob);
            fetch
            .post(url, formData)
            .then(() => {})
            .catch(() => {});
        },
        validate() {
            // console.info('validation upload file');
            // console.info('this.fileList.length', this.fileList.length);
            // console.info('this.minLength', this.minLength);
            // console.info('this.limit', this.limit);
            if (this.fileList.length < this.minLength) {
                // console.info('this.fileList.length < this.minLength');
                this.setStyleColors(true);
                this.hasErrors = true;
                return false;
            }

            if (this.fileList.length > this.limit) {
                // console.info('this.fileList.length > this.limit');
                this.setStyleColors(true);
                this.hasErrors = true;
                return true;
            }

            this.hasErrors = false;
            this.setStyleColors(false);
            return true;
        }
    },
    watch: {
        fileList: function(val) {
            // console.info('this..', this);
            this.validate();
        },
        required : function(val) {
            // console.info('required', val);
            if (this.hasErrors) {
                this.setStyleColors(val);
            }
        }
    }
};
